import { useState } from "react";

export const faqs = [
  {
    q: "What do I do if I need a passport in less than 24 hours in Cocoa Beach?",
    a: "If you need a passport in under 24 hours, you have two main paths: (1) Contact the Miami Passport Agency directly — but appointments are extremely limited and typically reserved for life-or-death emergencies with proof of travel. (2) Use Fast Passport Center&apos;s same-day emergency courier service — we submit directly through reserved agency slots — as a registered courier, we have guaranteed submission availability so you don&apos;t need to secure a hard-to-get appointment. We handle thousands of urgent cases annually and can often turn around passports within 24 hours when eligibility requirements are met. Call 877-253-0084 immediately if your travel is within 24–48 hours.",
  },
  {
    q: "How fast can I get a passport in Cocoa Beach, FL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a Cocoa Beach area post office or Brevard County clerk can take 2–6 months, especially during peak cruise and surf seasons.",
  },
  {
    q: "Do I need to visit an office in Cocoa Beach?",
    a: "Most travelers start online and ship their documents via overnight courier — no office visit required. In some cases, a courier pickup or by-appointment drop-off may be available after you sign up and your order is confirmed (availability varies).",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Do cruise passengers from Port Canaveral need passports?",
    a: "Yes. While some cruise lines allow closed-loop cruises with a birth certificate and ID, most international cruises from Port Canaveral require valid passports for every passenger, including children. If you need emergency medical evacuation in a foreign port, a passport is required for re-entry. We strongly recommend all cruise passengers carry valid passports — and Fast Passport Center can process yours fast — as a registered courier, we have guaranteed submission availability at the Miami Passport Agency.",
  },
  {
    q: "Can I get an expedited passport if I've never had one before?",
    a: "Yes, but first-time applicants typically require an in-person acceptance clerk visit before documents can be submitted for expedited processing. We guide you through exactly what to do and where to go in the Cocoa Beach area.",
  },
  {
    q: "What is the closest passport agency to Cocoa Beach?",
    a: "The closest regional passport agency is the Miami Passport Agency, located at the Omni Center, 1501 Biscayne Blvd, Suite 210, Miami, FL 33132 — about 180 miles south. However, regional agencies require appointments and are typically reserved for urgent travel emergencies. Fast Passport Center can often provide a faster, more predictable option using approved courier submission.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
  {
    q: "What if I need a child passport in Cocoa Beach?",
    a: "Child passports (for minors 15 and under) require parental participation and an in-person acceptance step — both parents typically must consent. We provide clear instructions and a checklist so you know exactly what to do. Expedited processing options are available after the acceptance step.",
  },
  {
    q: "Can I get a passport if mine is lost or stolen?",
    a: "Yes. Lost or stolen passport replacements often require additional forms (including Form DS-64 to report the lost passport). We guide you through exactly what's needed and help ensure the correct process is followed to avoid delays.",
  },
  {
    q: "Why should I use a registered passport courier instead of the Post Office?",
    a: "Instead of navigating the process alone, you'll have access to registered passport couriers with more than 20 years of experience. We review your paperwork, provide status updates, answer questions, and help resolve issues before they become delays. If a photo, document, or application problem arises, we can explain exactly what's needed and help get your application back on track quickly. Unlike the Post Office route where you mail in your application and wait, a registered courier gives you a dedicated professional who knows your name and your case — someone who actually answers the phone when you call and provides real updates instead of leaving you staring at a tracking number.",
  },
  {
    q: "Where can I get an emergency passport in Cocoa Beach today?",
    a: "The only same-day option is a regional passport agency — the nearest to Cocoa Beach is the Miami Passport Agency at 1501 Biscayne Blvd, Miami FL, over 3 hours away. That agency only serves life-or-death emergencies by appointment — walk-ins are not accepted. For most Cocoa Beach travelers the fastest realistic option is Fast Passport Center's courier service, processing in as little as 2–3 business days with no agency visit required.",
  },
  {
    q: "What is the fastest way to get a passport in Cocoa Beach?",
    a: "The fastest option for most Cocoa Beach travelers is Fast Passport Center's 2–3 business day courier service. Ship your documents overnight from anywhere on the Space Coast, we submit through reserved courier access, and your passport is returned to you. No travel to Miami, no appointment needed.",
  },
  {
    q: "Can I get a same-day passport in Cocoa Beach?",
    a: "Same-day processing is only available through a regional passport agency for documented life-or-death emergencies — the nearest to Cocoa Beach is the Miami Passport Agency, over 3 hours away, and requires a confirmed appointment. For most travelers same-day is not realistic. Fast Passport Center can process your passport in as little as 2–3 business days — the fastest option without an agency appointment.",
  },
  {
    q: "Is there a passport agency in Cocoa Beach?",
    a: "Cocoa Beach does not have its own regional passport agency. The closest is the Miami Passport Agency at 1501 Biscayne Blvd, Miami FL — approximately 180 miles from Cocoa Beach. That agency only serves documented life-or-death emergencies by appointment and is not available for standard expedited requests. Fast Passport Center's courier service is the fastest accessible alternative for Cocoa Beach travelers.",
  },
];

export default function CocoaBeachFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Cocoa Beach and Space Coast travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}